module.exports = __webpack_public_path__ + "static/media/login-bg.f93e22ed.png";